module.exports = __webpack_public_path__ + "static/gdmc_hero-5e36d3051e129cca1dac1f3aec080528.jpg";